<template>
  <p>
    <router-view></router-view>
  </p>
  <div class="site_footer">
    <div style="padding: 20px 50px;">
      <el-row>
        <el-col :span="8">
          <div>
            <div class="foot_area_title">
              全国服务热线
            </div>
            <br>
            <b>+86 18121217006</b>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="follow">
            <div>
              <div class="foot_area_title">
                关注我们
              </div>
              <br>
              <div class="contactUs">
                从这些地方可以找到我们：<br><br>
                邮箱：<br><a href="mailto:zhaoboya@chenxichem.com">zhaoboya@chenxichem.com</a><br>
              </div>
            </div>
            <div>
                <div class="bshare-custom bdsharebuttonbox bdshare-button-style0-16" data-bd-bind="1695426538317">
                    <div class="bsPromo bsPromo2"></div>
                </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="f3">
            <p>地址：中国(浙江)自由贸易试验区舟山市定海区北蝉乡(综保区)<br><br>
            舟山经济开发区新港园区迎宾大道116号(B座)1006-10号</p><br>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          © 2023 版权所有 <a href="http://www.chenxichem.com/" target="_blank" style="color: #fff; margin-right: 10px;">舟山辰熙新材料有限公司</a>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">浙ICP备2023035334号-1</a><br>
          <img src="../../../assets/images/police.png" style="width: 16px; height: 16px;"/> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33090202000576" rel="noreferrer" target="_blank"  style="color: #fff;">浙公网安备33090202000576</a>
        </el-col>
      </el-row>
    </div>
  </div>
    
</template>
  
  <script>
  
  export default {
    name: 'appCN',
    components: {
    }
  }
  </script>
  
  <style>
  .site_footer {
    background: rgb(35, 35, 35);
    color: antiquewhite;
    text-align: left;
  }
  .foot_area_title {
    font-size: 16px;
    font-weight: 700;
  }

.contactUs a{
  color: #fff;
  text-decoration: underline;
}
  </style>
  